import { Container, Typography, Grid, Box, Button } from '@mui/material';
import { getImageUrl } from '../../utils';

const aboutImage = getImageUrl('Welcome.png');

const About = () => (
  <Box
    sx={{
      background: 'linear-gradient(180deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.6) 100%)',
      backdropFilter: 'blur(6px)',
      py: { xs: 6, md: 10 },
      px: { xs: 2, md: 4 },
      borderTop: '1px solid rgba(0,0,0,0.05)',
    }}
  >
    <Container maxWidth="lg">
      <Grid container spacing={6} alignItems="center" justifyContent="center">
        {/* Text Section */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.65)',
              backdropFilter: 'blur(10px)',
              borderRadius: '1.25rem',
              boxShadow: '0 8px 24px rgba(0,0,0,0.05)',
              px: { xs: 3, md: 5 },
              py: { xs: 4, md: 6 },
            }}
          >
            <Typography
              variant="overline"
              sx={{
                fontSize: '0.85rem',
                fontWeight: 600,
                color: '#A2257C',
                letterSpacing: '1px',
                mb: 1,
              }}
            >
              Välkommen!
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontFamily: 'var(--font-heading)',
                fontWeight: 700,
                fontSize: { xs: '2rem', md: '2.75rem' },
                color: '#1e1e1e',
                mb: 2,
              }}
            >
              Pilates Höganäs
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '1rem', md: '1.15rem' },
                lineHeight: 1.8,
                color: '#444',
                mb: 4,
              }}
            >
              Vi erbjuder personlig träning, towerklasser och klassiska mattklasser i olika nivåer –
              allt i en rofylld miljö mitt i Höganäs.
            </Typography>

            <Button
              variant="contained"
              href="/sidepages/about-info"
              sx={{
                background: 'linear-gradient(135deg, #A2257C, #00b5bf)',
                color: 'white',
                px: 4,
                py: 1.25,
                fontSize: '1rem',
                fontWeight: 600,
                borderRadius: '999px',
                textTransform: 'none',
                boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #8b1d69, #007C85)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                },
              }}
            >
              Se mer om Pilates Höganäs
            </Button>
          </Box>
        </Grid>

        {/* Image Section */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              height: { xs: 300, md: 420 },
              borderRadius: '1.25rem',
              overflow: 'hidden',
              boxShadow: '0 12px 32px rgba(0,0,0,0.08)',
              position: 'relative',
              transition: 'transform 0.4s ease',
              '&:hover': {
                transform: 'scale(1.015)',
              },
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                background:
                  'linear-gradient(to bottom right, rgba(255,255,255,0.05), rgba(0,0,0,0.04))',
                zIndex: 1,
              }}
            />
            <Box
              sx={{
                height: '100%',
                width: '100%',
                backgroundImage: `url(${aboutImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                zIndex: 0,
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default About;
